const enumColumnFilterNames = {

  // Faktura/abb.ansvarlig
  BILLING_CONTACT:  'billingContact',

  // Kundeansvarlig
  CUSTOMER_CONTACT: 'customerContact',

  // EOS-ansvarlig
  EOS_CONTACT:      'eosContact',

  // EOS-leverandør
  EOS_SUPPLIER:     'eosSupplier'
};

function addDataToFilterList(data, filterList) {

  let filterValueInUseMap = {};
  let selectBoxFilters    = {};

  function init() {
    Object.keys(enumColumnFilterNames)
      .forEach(enumColumnFilterName => {
        const filterName = enumColumnFilterNames[enumColumnFilterName];
        filterValueInUseMap[filterName] = {};
        selectBoxFilters[filterName] = filterList.find(filterItem => filterItem.id === filterName);
      });

    data.forEach((dataRow) => addData(dataRow));
  }

  function addData(dataRow) {
    Object.keys(enumColumnFilterNames)
      .forEach(enumColumnFilterName => {
        const filterName = enumColumnFilterNames[enumColumnFilterName];
        const value = dataRow[filterName];
        addValueToFilterList(value, enumColumnFilterName, filterName);
      });
  }

  function addValueToFilterList(value, enumColumnFilterName, filterName) {
    if (value != null && filterValueInUseMap[filterName][value] !== true) {
      filterValueInUseMap[filterName][value] = true;

      if (selectBoxFilters[filterName]) {
        selectBoxFilters[filterName].data.push(value);
      }
    }
  }

  function clearFilterListData() {
    filterList.forEach(list => {
      list.data = [];
    });
  }

  clearFilterListData();
  init();
}

export default {
  enumColumnFilterNames,
  addDataToFilterList
}
